import base from './base';
import demandList from './demandList';
import productList from './productList';
import modifyPassword from './modifyPassword';
import applyAccount from './applyAccount';
import commodityList from './commodityList';
import shoppingCart from './shoppingCart';
import baseOrder from './baseOrder';
import orderList from './orderList';
import address from './address';
import settle from './settle';
import components from './components';
import orderDetails from './orderDetails';
import shipmentDetails from './shipmentDetails';
import login from './login';

const locale = {
  ...base,
  ...productList,
  ...demandList,
  ...modifyPassword,
  ...applyAccount,
  ...commodityList,
  ...shoppingCart,
  ...baseOrder,
  ...orderList,
  ...address,
  ...settle,
  ...components,
  ...orderDetails,
  ...shipmentDetails,
  ...login,
};

export default locale;
